import jwtDecode from 'jwt-decode'
import { GetterTree } from 'vuex'

import { TokenV2Body } from '@/models'

import { RootState } from '../state'
import { AuthState } from './state'

const getters: GetterTree<AuthState, RootState> = {
  /**
   * Reads the TokenV2 and returns a providerId.
   */
  currentProvider (state): number | null {
    const { tokenV2 } = state

    if (tokenV2 !== null) {
      const jwt = jwtDecode<TokenV2Body>(tokenV2)

      const providerId = typeof jwt.AccountId === 'string'
        ? jwt.AccountId
        : jwt.AccountId[0]

      return parseInt(providerId, 10)
    }

    return null
  },

  /**
   * Checks if the user is authenticated.
   */
  isAuthenticated (state) {
    return state.token !== null && state.tokenV2 !== null
  }
}

export default getters
